import {
  ADMIN_DASHBOARD,
  ADMIN_DASHBOARD_SUCCESS,
  ADMIN_DASHBOARD_FAILURE,
} from 'store/AdminDashboard/AdminDasboardAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const adminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_DASHBOARD:
      return { ...state, loading: true };
    case ADMIN_DASHBOARD_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case ADMIN_DASHBOARD_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default adminDashboardReducer;
